import React, { useEffect } from "react";
import Title from "../../components/helmet/title";
import { useRefundQuery } from "../../redux/feature/slice/service-api";
import DOMPurify from "dompurify";

const Refund = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data } = useRefundQuery();
  const refund = DOMPurify.sanitize(data?.data?.refund_policy);

  return (
    <section className="container mx-auto px-2 lg:px-20 my-10 lg:my-20 mt-14 md:mt-0">
      <Title title={"Refund"} content={"This is refund policy page"} />
      <h2 className="text-center text-xl lg:text-4xl font-medium">
        Refund Policy
      </h2>
      <div className="my-10">
        <div dangerouslySetInnerHTML={{ __html: refund }} />
      </div>
    </section>
  );
};

export default Refund;
